import { PdfItem } from '../../pages/pdf/types';

interface Props {
  data: PdfItem['data'];
}

export const PdfOrderedList = ({ data }: Props) => {
  const { item } = data;

  return (
    <>
      <ol className="px-2">
        {item.map((item, index) => (
          <li key={index} className="my-1">
            {item}
          </li>
        ))}
      </ol>
    </>
  );
};
